import React from "react";
import clsx from 'clsx';
import { withStyles } from '@material-ui/styles';
import moment from "moment";

import withLocationSearchFilter from '../../../../hocs/with_location_search_filter.js';
import withCurrentUser from '../../../../hocs/with_current_user.js';
import withShowToast from '../../../../hocs/with_show_toast.js';
import withShowModal from '../../../../hocs/with_show_modal.js';
import withScrollHandler from "../../../../hocs/with_scroll_handler.js";
import { compose } from 'redux';

import I18n from "../../../../base/i18n.js";
import Button from "../../../../base/buttons/button.js";

import pageStyles from "../../../styles/page_styles.js";
import { infoPageStyles } from "../../base_info_page.js";

import BaseInfoPage from "../../base_info_page.js";

import { AdminUserModel } from "../../../../models/users/admin/user_model.js";
import ShowUserUseCase from "../../../../use_cases/admin/users/users/show_user_use_case.js";
import UpdateUserUseCase from "../../../../use_cases/admin/users/users/update_user_use_case.js";
import DeleteUserUseCase from "../../../../use_cases/admin/users/users/delete_user_use_case.js";

import InfoPageHeader from "../../components/info_page_header.js";
import NavigationTabs from "../../components/navigation_tabs.js";

import UserInfoTab from "./components/user_info_tab.js";
import UserInvestmentsTab from "./components/user_investments_tab.js";
import UserWebIdFilesTab from "./components/user_web_id_files_tab.js";

import { StatisticsUpdateContext } from "./components/statistics_update_context.js";

import Routes from "../../../routes.js";

const styles = theme => ({
  emailLink: {
    fontSize: "16px",
    color: theme.palette.grayText
  }
});

const InfoTabIdentifier        = "info";
const InvestmentsTabIdentifier = "investments";
const WebIdFilesTabIdentifier  = "web_id_files";

class UserInfoPage extends BaseInfoPage {

  constructor(props) {
    super(props);

    this.tabs = [
      {
        identifier: InfoTabIdentifier,
        label: I18n.t("admin.users.user.tabs.info")
      },
      {
        identifier: InvestmentsTabIdentifier,
        label: I18n.t("admin.users.user.tabs.investments"),
        queryParams: this.investmentsDefault()
      },
      {
        identifier: WebIdFilesTabIdentifier,
        label: I18n.t("admin.users.user.tabs.web_id_files")
      }
    ]

    if(!this.state.currentTab) {
      this.state.currentTab = this.tabs[0].identifier;
    }
    this.state.lastLoad = moment().unix();

    this.onSoftDelete = this.onSoftDelete.bind(this);
    this.onUnDelete = this.onUnDelete.bind(this);
  }

  componentDidMount() {
    super.componentDidMount();
    this.updateInvestmentParams();
  }

  componentDidUpdate(prevProps, prevState) {
    super.componentDidUpdate(prevProps, prevState);
    this.updateInvestmentParams();
  }

  loadItem() {
    this.processDataLoader(this.showUseCase.execute(this.identifier));
  }

  processLoadedItem(result) {
    const { data: { user } } = result;
    this.item = user;
  }

  onChangeFilter = (name, value) => {
    const { changeLocationSearch } = this.props;

    changeLocationSearch({
      [name]: value
    }, {replaceLocation: true});
  }

  updateInvestmentParams = () => {
    const investmentsTab = this.investmentsTab();
    const { currentTab } = this.state;
    if(currentTab === InvestmentsTabIdentifier) {
      investmentsTab.queryParams = this.props.filterData;
    }
  }

  investmentsTab = () => {
    return this.tabs.filter(tab => tab.identifier === InvestmentsTabIdentifier)[0];
  }

  investmentsDefault = () => {
    return {
      investmentStatuses: ["applied", "paid"]
    }
  }

  header() {
    const { currentTab } = this.state;
    return <React.Fragment>
      <InfoPageHeader title = { this.pageTitle() }
                      subtitle = { this.pageSubtitle() } >
        { this.headerContent() }
      </InfoPageHeader>
      {
        this.identifier &&
        <NavigationTabs tabs = { this.tabs }
                        currentTab = { currentTab }
                        onChangeTab = { this.onChangeTab } />
      }
    </React.Fragment>
  }

  pageSubtitle() {
    const { loading } = this.state;
    if(!this.identifier || loading) {
      return "";
    }
    return I18n.t("admin.users.user.subtitle", {code: this.item.code});
  }

  content() {
    const { errorData, currentTab, loading, lastLoad } = this.state;

    return <StatisticsUpdateContext.Provider value = { {
        lastLoad: lastLoad,
        updateLastLoad: this.updateLastLoad
      } }>
        <React.Fragment key = { this.item.key } >
          {
            !loading && <UserInfoTab user = { this.item }
                                     errorData = { errorData }
                                     onItemChanged = { this.onItemChange }
                                     visible = { currentTab === InfoTabIdentifier }/>
          }
          {
            !loading &&
            <UserInvestmentsTab user = { this.item }
                                visible = { currentTab === InvestmentsTabIdentifier }
                                filterData = { {...this.investmentsTab().queryParams} }
                                onChangeFilter = { this.onChangeFilter } />
          }
          {
            !loading &&
            <UserWebIdFilesTab user = { this.item }
                               visible = { currentTab === WebIdFilesTabIdentifier } />
          }
        </React.Fragment>
      </StatisticsUpdateContext.Provider>
  }

  buttonsIsVisible() {
    const { currentTab } = this.state;
    return currentTab === InfoTabIdentifier;
  }

  updateLastLoad = () => {
    this.setState({
      lastLoad: moment().unix()
    })
  }

  UnDeletedMessage() {
    return I18n.t("shared.toast.successfully_undeleted");
  }

  onUnDelete() {
    this.setState({
      submit: true
    })
    UpdateUserUseCase.execute(this.identifier, {archived_at: "false"})
    .then(() => {
      this.props.showSuccessMessage(this.UnDeletedMessage());
      this.item.archivedAt = null
      this.setState({
        submit: false,
      });
    })
    .catch((result) => {

      const { errorData } = result;
      this.setState({
        submit: false,
        errorData: errorData
      });
      this.props.showServerErrorIfNeed(result);

      this.afterSaveFail();
    })
  }

  SoftDeletedMessage() {
    return I18n.t("shared.toast.successfully_deleted");
  }

  onSoftDelete() {
    this.setState({
      submit: true
    })
    UpdateUserUseCase.execute(this.identifier, {archived_at: new Date().toISOString()})
    .then(() => {
      this.props.showSuccessMessage(this.SoftDeletedMessage());
      this.item.archivedAt = new Date().toISOString()
      this.setState({
        submit: false,
      });
    })
    .catch((result) => {

      const { errorData } = result;
      this.setState({
        submit: false,
        errorData: errorData
      });
      this.props.showServerErrorIfNeed(result);

      this.afterSaveFail();
    })
  }

  deleteConfirmMessage() {
    return I18n.t("admin.users.user.delete.confirm_message", {
      name: this.dataModel.displayValue(this.item)
    });
  }

  rightButtons() {
    const { classes } = this.props;
    const { submit, loading } = this.state;

    if(!this.identifier) {
      return <React.Fragment />
    }

    var has_paid_investment = false
    if(this.item.investments)
    this.item.investments.forEach(element => {
      if(element.status == 'paid' || element.status == 'paid_back') {
        has_paid_investment = true
      }
    });

    if(this.item.archivedAt) {
      return  <React.Fragment>
                <Button className = { clsx(classes.formButton, classes.delete) }
                      disabled = { submit || loading }
                      onClick = { this.onUnDelete } >
                  { I18n.t("action.undelete") }
                </Button>
                <Button className = { clsx(classes.formButton, classes.delete, classes.formButtonsRight) }
                        disabled = { submit || loading || has_paid_investment }
                        onClick = { this.onDelete } >
                  { I18n.t("action.harddelete") }
                </Button>
              </React.Fragment>
    } else {
      return  <Button className = { clsx(classes.formButton, classes.delete) }
                disabled = { submit || loading || has_paid_investment }
                onClick = { this.onSoftDelete } >
                { I18n.t("action.delete") }
              </Button>
    }
  }
}

UserInfoPage.defaultProps = {
  dataModel: AdminUserModel,
  showUseCase: ShowUserUseCase,
  saveUseCase: UpdateUserUseCase,
  deleteUseCase: DeleteUserUseCase,
  routeFunc: Routes.user
}

export default compose(
  withLocationSearchFilter,
  withShowToast,
  withCurrentUser,
  withShowModal,
  withScrollHandler,
  withStyles(
    (theme) => ({
      ...pageStyles(theme),
      ...infoPageStyles(theme),
      ...styles(theme),
    }),
    { withTheme: true }
  )
)(UserInfoPage);
